import React, { useCallback } from 'react'

import Translator from 'bazinga-translator'
import Button from 'components/Btn'
import useChangeCategory from 'components/GamesNavBar/hooks/useChangeCategory'
import { Category } from 'containers/GamesBlock/types'

import { CategoryHeader, CategoryLabel } from './styles'

interface Props {
  category: Category
}

export function Header({ category }: Props) {
  const { changeCategory } = useChangeCategory()
  const { label, slug } = category

  const onClick = useCallback(() => {
    changeCategory(slug), [changeCategory, slug]
  }, [slug, changeCategory])

  return (
    <CategoryHeader>
      <CategoryLabel onClick={onClick}>{label}</CategoryLabel>
      <Button
        onClick={onClick}
        link
        secondary
        sm
      >
        {Translator.trans('all', {}, 'messages')}
      </Button>
    </CategoryHeader>
  )
}
